import checkout from '@/store/modules/checkout';
import cart from '@/store/modules/cart';
import store from '@/store';
import {normalizeQuoteAddress} from '@/commons/addressNormalizer';
import {PaidEventPayload, PaymentInformationRequest} from '@/store/models';
import redirectToLocation from '@/commons/redirectManager';
import handleError from '@/commons/errorHandler';
import {i18n} from '@/i18n';
import handleMessage from '@/commons/messageManager';
import {bus} from './bus';

const event = 'checkout.paid';

export default event;

bus.$on(event, (payload: PaidEventPayload) => {
    let request: PaymentInformationRequest;
    let checkoutMethod = 'placeOrder';
    let placeCallback: any;

    if (payload.useStoredData && localStorage.getItem('payment-request')) {
        request = JSON.parse(localStorage.getItem('payment-request') as string);
    } else {
        const {payData} = payload;

        // eslint-disable-next-line no-prototype-builtins
        if (payData.hasOwnProperty('checkoutMethod')) {
            checkoutMethod = payData.checkoutMethod;
            delete payData.checkoutMethod;
        }

        // eslint-disable-next-line no-prototype-builtins
        if (payData.hasOwnProperty('placeCallback')) {
            placeCallback = payData.placeCallback;
            delete payData.placeCallback;
        }

        let {billingAddress} = checkout;

        if (checkout.billingSameAsShipping) {
            const shippingAddressClone = normalizeQuoteAddress(checkout.shippingAddress);
            delete shippingAddressClone.id;

            if (checkout.requestInvoice.requested) {
                shippingAddressClone.vat_id = billingAddress.vat_id;
                shippingAddressClone.company = billingAddress.company;
                shippingAddressClone.extension_attributes.pec = billingAddress.extension_attributes.pec;
                shippingAddressClone.extension_attributes.sdi_code = billingAddress.extension_attributes.sdi_code;
            } else {
                shippingAddressClone.vat_id = '';
                shippingAddressClone.company = '';
                shippingAddressClone.extension_attributes.pec = '';
                shippingAddressClone.extension_attributes.sdi_code = '';
            }

            checkout.setBillingAddress(shippingAddressClone);
            billingAddress = shippingAddressClone;
        }

        request = {
            cartId: cart.cartToken.toString() !== '' ? cart.cartToken : cart.cart.id,
            billingAddress: normalizeQuoteAddress(billingAddress),
            email: checkout.email,
            paymentMethod: {
                method: payload.paymentMethod,
                po_number: undefined,
                additional_data: payData.additional_data || checkout.additionalData,
            },
        };
        if (payData && payData.extension_attributes && request.paymentMethod) {
            request.paymentMethod.extension_attributes = payData.extension_attributes;
        }

        delete request.billingAddress.default_shipping;
        delete request.billingAddress.default_billing;

        // eslint-disable-next-line no-prototype-builtins
        if (request.billingAddress.hasOwnProperty('id')) {
            delete request.billingAddress.id;
        }

        localStorage.setItem('payment-request', JSON.stringify(request));
    }

    if (payload.doNotPlaceOrder) {
        return;
    }

    store
        .dispatch(`checkout/${checkoutMethod}`, request)
        .then((orderData: any) => {
            localStorage.removeItem('payment-request');

            if (orderData) {
                if (placeCallback) {
                    placeCallback(orderData);
                } else {
                    handleMessage('success', i18n.t('Order placed').toString());
                    cart.reset();
                    checkout.reset();
                    setTimeout(() => {
                        redirectToLocation(payload.redirectUrl);
                    }, 1000);
                }
            } else {
                handleMessage('error', i18n.t('Error occurred while placing order').toString());
            }
        })
        .catch(e => {
            handleError(e);
            localStorage.removeItem('payment-request');
        });
});
